import React from 'react'

const Services = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Services</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
      <h6>Services provided by HSDC</h6>

<p>The HSDC a pioneer in the area of Seed Production and Marketing.
    It has got best expertise in the following fields:</p>

<ul>
    <li>Seed Production</li><hr/>
    <li>Certification</li><hr/>
    <li>Seed Quality Control</li><hr/>
    <li>Seed Processing, Handling, Packaging and Storage</li><hr/>
    <li>Seed Marketing</li><hr/>
    <li>Information, Communication and Public Relations</li><hr/>
    <li>Sales Promotion and Advertising of Seeds</li><hr/>
</ul>
      </div>
    </div>
  )
}

export default Services
